import { createFeatureSelector, createSelector } from '@ngrx/store'
import { USER_ACCOUNTS_FEATURE_KEY, UserAccountsState, userAccountsAdapter } from './user-accounts.reducer'

export const selectUserAccountsState = createFeatureSelector<UserAccountsState>(USER_ACCOUNTS_FEATURE_KEY)

const { selectAll, selectEntities } = userAccountsAdapter.getSelectors()

export const selectUserAccountsLoaded = createSelector(
  selectUserAccountsState,
  (state: UserAccountsState) => state.loaded,
)

export const getUserAccountSaving = createSelector(selectUserAccountsState, (state: UserAccountsState) => state.saving)

export const selectUserAccountsCount = createSelector(
  selectUserAccountsState,
  (state: UserAccountsState) => state.count,
)

export const selectAllUserAccounts = createSelector(selectUserAccountsState, (state: UserAccountsState) =>
  selectAll(state),
)

export const selectUserAccountsEntities = createSelector(selectUserAccountsState, (state: UserAccountsState) =>
  selectEntities(state),
)

export const selectSelectedId = createSelector(selectUserAccountsState, (state: UserAccountsState) => state.selectedId)

export const selectEntity = createSelector(selectUserAccountsEntities, selectSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
)
export const selectSearchHistory = createSelector(
  selectUserAccountsState,
  (state: UserAccountsState) => state.searchHistory,
)
